"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKX_MINI_WALLET_NAME = exports.OKX_APP_WALLET_NAME = exports.stackDeepLink = exports.tgwalletAppName = exports.tgwalletName = exports.tonConnectSdkVersion = exports.shortUniversalLink = exports.standardDeeplink = exports.downloadUrl = exports.standardUniversalLink = exports.okxDeeplink = void 0;
exports.getTestTwaUrl = getTestTwaUrl;
exports.getTestTgTwaUrl = getTestTgTwaUrl;
exports.getBotNameAndAppName = getBotNameAndAppName;
exports.okxDeeplink = 'okx://web3';
exports.standardUniversalLink = typeof window !== "undefined" && window.location.hostname.includes("okx.com")
    ? "https://link.okx.com/download"
    : "https://www.okx.com/download";
exports.downloadUrl = "https://www.okx.com/download";
// export const standardUniversalLink = 'http://localhost:5173';
exports.standardDeeplink = `${exports.okxDeeplink}/wallet/connect`;
exports.shortUniversalLink = `https://www.okx.com/ul/connect`;
// export const standardDeeplink = 'http://localhost:5173';
exports.tonConnectSdkVersion = '1';
// export const tgwalletName: string = "TCTestqdqwdqwdqBot"
exports.tgwalletName = "OKX_WALLET_BOT";
exports.tgwalletAppName = "start";
// https://t.me/OKX_WALLET_BOT/start
exports.stackDeepLink = 'okx://web3?stack=true';
function getTestTwaUrl() {
    return window.okxTesttwaUrl;
}
function getTestTgTwaUrl() {
    return window.okxTestTgtwaUrl;
}
function getBotNameAndAppName(url) {
    const urlObj = new URL(url);
    const pathnameParts = urlObj.pathname.split('/').filter(Boolean);
    if (pathnameParts.length >= 2) {
        const botName = pathnameParts[0]; // 获取 'test_12312313123_bot'
        const appName = pathnameParts[1]; // 获取 'testtest'
        return { botName, appName };
    }
}
exports.OKX_APP_WALLET_NAME = 'OKX Wallet';
exports.OKX_MINI_WALLET_NAME = 'OKX Mini Wallet';
